// This file is auto-generated. Do not edit directly.
// Generated from configuration/groups/pinnacle/document-mappings.yaml
// Run: bun run scripts/mappings/pinnacle-make-mappings-from-yaml.ts
import { DocumentMapping } from "@/configuration/document-mappings/types";
import { Classification } from "@/src/models/constants/classifications";

export const PINNACLE_MAPPINGS: Partial<Record<Classification, DocumentMapping>> = {
  [Classification.ADMIN_CASE_MANAGER_DOCUMENTS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "McCoy,Kathy",
    displayName: "Case Manager Documents (Social Workers, Insurance Case Management, CCM)",
    documentLabel: "{{ dateOfDocument }} {{ nameOfDocument }}",
    folder: "Case Manager",
    folderMapping: "Case Manager",
    inputDate: "Date of Document",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_CASE_MANAGER_DOCUMENTS,
    group: "pinnacle"
  },
  [Classification.ADMIN_CERTIFICATE_OF_MEDICAL_NECESSITY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "MA (linked to Pt's PCP)",
    displayName: "Certificate of Medical Necessity",
    documentLabel: "{{ dateReceived }} CMN {{ equipmentOrSupply }}",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_CERTIFICATE_OF_MEDICAL_NECESSITY,
    group: "pinnacle"
  },
  [Classification.ADMIN_DEATH_CERTIFICATES]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Patient's PCP",
    displayName: "Death Certificates",
    documentLabel: "{{ dateOfEvent }} Death Cert",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Date of Death",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_DEATH_CERTIFICATES,
    group: "pinnacle"
  },
  [Classification.ADMIN_DISABILITY_FORMS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "MA (linked to Pt's PCP)",
    displayName: "Disability Forms",
    documentLabel: "{{ dateReceived }} EDD Forms",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Received Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_DISABILITY_FORMS,
    group: "pinnacle"
  },
  [Classification.ADMIN_FMLA_FORMS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "MA (linked to Pt's PCP)",
    displayName: "FMLA Forms",
    documentLabel: "{{ dateReceived }} FMLA",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_FMLA_FORMS,
    group: "pinnacle"
  },
  [Classification.ADMIN_HEAD_START_PROGRAM]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "MA (linked to Pt's PCP)",
    displayName: "Head Start Program",
    documentLabel: "{{ dateReceived }} Head Start",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_HEAD_START_PROGRAM,
    group: "pinnacle"
  },
  [Classification.ADMIN_PATIENT_SHARED_INFORMATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Patient's PCP",
    displayName: "Patient Logs (Blood Pressure/Glucose/Meds)",
    documentLabel: "{{ dateReceived }} {{ patientLogType }} Log",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Date received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_PATIENT_SHARED_INFORMATION,
    group: "pinnacle"
  },
  [Classification.ADMIN_RESPONSE_FROM_OUTSIDE_PROVIDER_RECORD_NOT_FOUND]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Location referrals",
    displayName: "Response from Outside Provider/Record Not Found",
    documentLabel: "{{ dateReceived }} Records Not Found {{ specialtyOrFacilityName }} ",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Received Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_RESPONSE_FROM_OUTSIDE_PROVIDER_RECORD_NOT_FOUND,
    group: "pinnacle"
  },
  [Classification.ADMIN_RETURN_TO_WORK]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "MA (linked to Pt's PCP)",
    displayName: "Return to Work",
    documentLabel: "{{ dateSigned }} RTW",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Date Signed",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_RETURN_TO_WORK,
    group: "pinnacle"
  },
  [Classification.ADMIN_RISK_ASSESSMENT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "MA (linked to Pt's PCP)",
    displayName: "Risk Assessment",
    documentLabel: "{{ dateReceived }} Risk Assessment",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_RISK_ASSESSMENT,
    group: "pinnacle"
  },
  [Classification.ADMIN_SCHOOL_NOTES]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "MA (linked to Pt's PCP)",
    displayName: "School Notes",
    documentLabel: "{{ dateSigned }} RTS",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Date Signed",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_SCHOOL_NOTES,
    group: "pinnacle"
  },
  [Classification.ADMIN_WORK_OR_SCHOOL_PHYSICAL_FORMS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "MA (linked to Pt's PCP)",
    displayName: "Work or School Physical Forms",
    documentLabel: "{{ dateSigned }} Work Excuse Dr {{ providerLastName }}",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Date signed",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_WORK_OR_SCHOOL_PHYSICAL_FORMS,
    group: "pinnacle"
  },
  [Classification.CLEARANCE_REQUEST_PRE_OP]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "MA (linked to Pt's PCP)",
    displayName: "Pre Op (Pre-Op)/Surgical Request/Clearance",
    documentLabel: "{{ dateReceived }} Pre-Op Clearance",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.CLEARANCE_REQUEST_PRE_OP,
    group: "pinnacle"
  },
  [Classification.CLEARANCE_REQUEST_SURGICAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "MA (linked to Pt's PCP)",
    displayName: "Surgical Clearance",
    documentLabel: "{{ dateReceived }} Surgical Clearance {{ specialty }}",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.CLEARANCE_REQUEST_SURGICAL,
    group: "pinnacle"
  },
  [Classification.CONSENT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Leave assignment as is & mark as reviewed",
    displayName: "Consent Forms",
    documentLabel: "{{ dateSigned }} Consent {{ nameOfDocument }}",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Date signed",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.CONSENT,
    group: "pinnacle"
  },
  [Classification.DME_DIABETIC_SUPPLIES]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "MA (linked to Pt's PCP)",
    displayName: "DME Requests for Diabetic Supplies",
    documentLabel: "{{ dateReceived }} DME {{ dmeType }} {{ orderNumber }}",
    folder: "DME",
    folderMapping: "DME",
    inputDate: "Received Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.DME_DIABETIC_SUPPLIES,
    group: "pinnacle"
  },
  [Classification.DME_ORDER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "MA (linked to Pt's PCP)",
    displayName: "DME Requests",
    documentLabel: "{{ dateReceived }} DME {{ dmeType }} {{ orderNumber }}",
    folder: "DME",
    folderMapping: "DME",
    inputDate: "Received Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.DME_ORDER,
    group: "pinnacle"
  },
  [Classification.FINANCIAL_BILLING_RECORDS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "ROI,D Jelly",
    displayName: "Billing Records received from PRS",
    documentLabel: "{{ dateReceived }} Billing Records from PRS",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Received Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.FINANCIAL_BILLING_RECORDS,
    group: "pinnacle"
  },
  [Classification.FINANCIAL_ELIGIBILITY_OF_BENEFITS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Leave assignment as is & mark as reviewed",
    displayName: "EOB/Elegibility Of Benefits",
    documentLabel: "{{ dateReceived }} EOB",
    folder: "EOB Documents",
    folderMapping: "EOB Documents",
    inputDate: "Received Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.FINANCIAL_ELIGIBILITY_OF_BENEFITS,
    group: "pinnacle"
  },
  [Classification.FINANCIAL_ELIGIBILITY_OF_BENEFITS_CREDIT_CARD]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Leave assignment as is & mark as reviewed",
    displayName: "EOB/Credit Cards",
    documentLabel: "{{ dateReceived }} EOB",
    folder: "EOB Documents",
    folderMapping: "EOB Documents",
    inputDate: "Received Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.FINANCIAL_ELIGIBILITY_OF_BENEFITS_CREDIT_CARD,
    group: "pinnacle"
  },
  [Classification.IDENTIFICATION_CARD]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Leave assignment as is & mark as reviewed",
    displayName: "Photo ID/Copy of Drivers License",
    documentLabel: "{{ dateReceived }} ID",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Received Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IDENTIFICATION_CARD,
    group: "pinnacle"
  },
  [Classification.IMAGING_RESULTS_COLONOSCOPY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "IF order exists: attach document to order and assign both document and order to 1) ordering provider or 2)PCP. Do not mark order received, and do not enter results.",
      "IF no order exists AND imaging was collected in the last 10 years, create an order and assign both order and document to 1)ordering provider or 2)PCP. Do not mark order received, and do not enter results.",
      "IF no order exists AND imaging was NOT collected in the last 10 years, do not create an order. Assign document to 1)ordering provider or 2)PCP.",
      "See Orders Workflow in Notion"
    ],
    assignedTo: "1)ordering provider or 2)PCP",
    displayName: "Colonoscopy",
    documentLabel: "{{ dateOfEvent }} Colonoscopy",
    folder: "Imaging- Colonoscopy",
    folderMapping: "Imaging/Colonoscopy",
    inputDate: "Date of Procedure",
    instructions: null,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.IMAGING_RESULTS_COLONOSCOPY,
    group: "pinnacle"
  },
  [Classification.IMAGING_RESULTS_CT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "IF order exists, attach document to order and assign both order and document to 1)ordering provider or 2)PCP. Do not mark order received.",
      "IF order does not already exist, do not create a new order. Assign the document to 1)ordering provider or 2) PCP.",
      "See Orders Workflow in Notion"
    ],
    assignedTo: "1)ordering provider or 2)PCP",
    displayName: "CT Scans",
    documentLabel: "{{ dateOfEvent }} CT {{ bodyPart }}",
    folder: "Imaging - CT Scans",
    folderMapping: "Imaging/CT Scans",
    inputDate: "Date of Study",
    instructions: null,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.IMAGING_RESULTS_CT,
    group: "pinnacle"
  },
  [Classification.IMAGING_RESULTS_DEXA]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "IF order exists: attach document to order and assign both document and order to 1) ordering provider or 2)PCP. Do not mark order received, and do not enter results.",
      "IF no order exists AND imaging was collected in the last 2 years, create an order and assign both order and document to 1)ordering provider or 2)PCP. Do not mark order received, and do not enter results.",
      "IF no order exists AND imaging was NOT collected in the last 2 years, do not create an order. Assign document to 1)ordering provider or 2)PCP.",
      "See Orders Workflow in Notion"
    ],
    assignedTo: "1)ordering provider or 2)PCP",
    displayName: "DEXA",
    documentLabel: "{{ dateOfEvent }} DEXA",
    folder: "Imaging - DEXA",
    folderMapping: "Imaging/DEXA",
    inputDate: "Date of Study",
    instructions: null,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.IMAGING_RESULTS_DEXA,
    group: "pinnacle"
  },
  [Classification.IMAGING_RESULTS_ECHO]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "IF order exists, attach document to order and assign both order and document to 1)ordering provider or 2)PCP. Do not mark order received.",
      "IF order does not already exist, do not create a new order. Assign the document to 1)ordering provider or 2) PCP.",
      "See Orders Workflow in Notion"
    ],
    assignedTo: "1)ordering provider or 2)PCP",
    displayName: "Echocardiogram",
    documentLabel: "{{ dateOfEvent }} Echo",
    folder: "Imaging - Echo",
    folderMapping: "Imaging/Echo",
    inputDate: "Date of Study",
    instructions: null,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.IMAGING_RESULTS_ECHO,
    group: "pinnacle"
  },
  [Classification.IMAGING_RESULTS_EEG]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "IF order exists, attach document to order and assign both order and document to 1)ordering provider or 2)PCP. Do not mark order received.",
      "IF order does not already exist, do not create a new order. Assign the document to 1)ordering provider or 2) PCP.",
      "See Orders Workflow in Notion"
    ],
    assignedTo: "1)ordering provider or 2)PCP",
    displayName: "EEG",
    documentLabel: "{{ dateOfEvent }} EEG",
    folder: "Neurological Tests",
    folderMapping: "Neurological Tests",
    inputDate: "Date of Study",
    instructions: null,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.IMAGING_RESULTS_EEG,
    group: "pinnacle"
  },
  [Classification.IMAGING_RESULTS_EKG]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "IF order exists, attach document to order and assign both order and document to 1)ordering provider or 2)PCP. Do not mark order received.",
      "IF order does not already exist, do not create a new order. Assign the document to 1)ordering provider or 2) PCP.",
      "See Orders Workflow in Notion"
    ],
    assignedTo: "1)ordering provider or 2)PCP",
    displayName: "EKG",
    documentLabel: "{{ dateOfEvent }} EKG",
    folder: "Imaging - Cardiac Tests",
    folderMapping: "Imaging/Cardiac Tests",
    inputDate: "Date of Study",
    instructions: null,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.IMAGING_RESULTS_EKG,
    group: "pinnacle"
  },
  [Classification.IMAGING_RESULTS_HOLTER_MONITOR]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "IF order exists, attach document to order and assign both order and document to 1)ordering provider or 2)PCP. Do not mark order received.",
      "IF order does not already exist, do not create a new order. Assign the document to 1)ordering provider or 2) PCP.",
      "See Orders Workflow in Notion"
    ],
    assignedTo: "1)ordering provider or 2)PCP",
    displayName: "Holter Monitor Report",
    documentLabel: "{{ dateOfEvent }} Holter",
    folder: "Imaging - Cardiac Tests",
    folderMapping: "Imaging/Cardiac Tests",
    inputDate: "Report Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.IMAGING_RESULTS_HOLTER_MONITOR,
    group: "pinnacle"
  },
  [Classification.IMAGING_RESULTS_MAMMOGRAM]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "IF order exists: attach document to order and assign both document and order to 1) ordering provider or 2)PCP. Do not mark order received, and do not enter results.",
      "IF no order exists AND imaging was collected in the last 3 years, create an order and assign both order and document to 1)ordering provider or 2)PCP. Do not mark order received, and do not enter results.",
      "IF no order exists AND imaging was NOT collected in the last 3 years, do not create an order. Assign document to 1)ordering provider or 2)PCP.",
      "See Orders Workflow in Notion"
    ],
    assignedTo: "1)ordering provider or 2)PCP",
    displayName: "Mammogram",
    documentLabel: "{{ dateOfEvent }} Mammo",
    folder: "Imaging - Mammogram",
    folderMapping: "Imaging/Mammogram",
    inputDate: "Procedure Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.IMAGING_RESULTS_MAMMOGRAM,
    group: "pinnacle"
  },
  [Classification.IMAGING_RESULTS_MRI]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "IF order exists, attach document to order and assign both order and document to 1)ordering provider or 2)PCP. Do not mark order received.",
      "IF order does not already exist, do not create a new order. Assign the document to 1)ordering provider or 2) PCP.",
      "See Orders Workflow in Notion"
    ],
    assignedTo: "1)ordering provider or 2)PCP",
    displayName: "MRI",
    documentLabel: "{{ dateOfEvent }} MRI {{ bodyPart }}",
    folder: "Imaging - MRI",
    folderMapping: "Imaging/MRI",
    inputDate: "Procedure Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.IMAGING_RESULTS_MRI,
    group: "pinnacle"
  },
  [Classification.IMAGING_RESULTS_NEEDS_CLARIFICATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "MA (linked to Pt's PCP)",
    displayName: "Imaging Orders needing clarification",
    documentLabel: "{{ dateReceived }} {{ imagingType }} Order Clarification Needed",
    folder: "Imaging - subfolder per {{ imagingType }}",
    folderMapping: "Imaging/{{ imagingType }}",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_NEEDS_CLARIFICATION,
    group: "pinnacle"
  },
  [Classification.IMAGING_RESULTS_NEEDS_SIGNATURE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "MA (linked to Pt's PCP)",
    displayName: "Imaging Orders needing signature",
    documentLabel: "{{ dateReceived }} {{ imagingType }} Order Sig Req'd",
    folder: "Imaging - subfolder per {{ imagingType }}",
    folderMapping: "Imaging/{{ imagingType }}",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_NEEDS_SIGNATURE,
    group: "pinnacle"
  },
  [Classification.IMAGING_RESULTS_NM]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "IF order exists, attach document to order and assign both order and document to 1)ordering provider or 2)PCP. Do not mark order received.",
      "IF order does not already exist, do not create a new order. Assign the document to 1)ordering provider or 2) PCP.",
      "See Orders Workflow in Notion"
    ],
    assignedTo: "1)ordering provider or 2)PCP",
    displayName: "Nuclear Medicine/Nuc Med/NM",
    documentLabel: "{{ dateOfEvent }} NM {{ studyType }}",
    folder: "Imaging- Nuclear Medicine",
    folderMapping: "Imaging/Nuclear Medicine",
    inputDate: "Procedure Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.IMAGING_RESULTS_NM,
    group: "pinnacle"
  },
  [Classification.IMAGING_RESULTS_PET]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "IF order exists, attach document to order and assign both order and document to 1)ordering provider or 2)PCP. Do not mark order received.",
      "IF order does not already exist, do not create a new order. Assign the document to 1)ordering provider or 2) PCP.",
      "See Orders Workflow in Notion"
    ],
    assignedTo: "1)ordering provider or 2)PCP",
    displayName: "PET Scan",
    documentLabel: "{{ dateOfEvent }} PET {{ bodyPart }}",
    folder: "Imaging - CT Scans",
    folderMapping: "Imaging/CT Scans",
    inputDate: "Procedure Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.IMAGING_RESULTS_PET,
    group: "pinnacle"
  },
  [Classification.IMAGING_RESULTS_PULMONARY_FUNCTION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "IF order exists, attach document to order and assign both order and document to 1)ordering provider or 2)PCP. Do not mark order received.",
      "IF order does not already exist, do not create a new order. Assign the document to 1)ordering provider or 2) PCP.",
      "See Orders Workflow in Notion"
    ],
    assignedTo: "1)ordering provider or 2)PCP",
    displayName: "Pulmonary Function Test (PFT)/Spirometry",
    documentLabel: "{{ dateOfEvent }} Spirometry",
    folder: "Imaging - Spirometry",
    folderMapping: "Imaging/Spirometry",
    inputDate: "Date of Exam",
    instructions: null,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.IMAGING_RESULTS_PULMONARY_FUNCTION,
    group: "pinnacle"
  },
  [Classification.IMAGING_RESULTS_STRESS_TEST_EXERCISE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "IF order exists, attach document to order and assign both order and document to 1)ordering provider or 2)PCP. Do not mark order received.",
      "IF order does not already exist, do not create a new order. Assign the document to 1)ordering provider or 2) PCP.",
      "See Orders Workflow in Notion"
    ],
    assignedTo: "1)ordering provider or 2)PCP",
    displayName: "Exercise Stress Test (treadmill stress test)",
    documentLabel: "{{ dateOfEvent }} Stress Test",
    folder: "Imaging - Cardiac Tests",
    folderMapping: "Imaging/Cardiac Tests",
    inputDate: "Date of Study",
    instructions: null,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.IMAGING_RESULTS_STRESS_TEST_EXERCISE,
    group: "pinnacle"
  },
  [Classification.IMAGING_RESULTS_STRESS_TEST_NM]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "IF order exists, attach document to order and assign both order and document to 1)ordering provider or 2)PCP. Do not mark order received.",
      "IF order does not already exist, do not create a new order. Assign the document to 1)ordering provider or 2) PCP.",
      "See Orders Workflow in Notion"
    ],
    assignedTo: "1)ordering provider or 2)PCP",
    displayName: "NM Stress Test (Bruce Protocol, Lexiscan, Cardiolite)",
    documentLabel: "{{ dateOfEvent }} NM {{ studyType }}",
    folder: "Imaging - Nuclear Medicine",
    folderMapping: "Imaging/Nuclear Medicine",
    inputDate: "Procedure Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.IMAGING_RESULTS_STRESS_TEST_NM,
    group: "pinnacle"
  },
  [Classification.IMAGING_RESULTS_ULTRASOUND]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "IF order exists, attach document to order and assign both order and document to 1)ordering provider or 2)PCP. Do not mark order received.",
      "IF order does not already exist, do not create a new order. Assign the document to 1)ordering provider or 2) PCP.",
      "See Orders Workflow in Notion"
    ],
    assignedTo: "1)ordering provider or 2)PCP",
    displayName: "Ultrasound",
    documentLabel: "{{ dateOfEvent }} US {{ bodyPart }}",
    folder: "Imaging - Ultrasounds",
    folderMapping: "Imaging/Ultrasounds",
    inputDate: "Procedure Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.IMAGING_RESULTS_ULTRASOUND,
    group: "pinnacle"
  },
  [Classification.IMAGING_RESULTS_X_RAY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "IF order exists, attach document to order and assign both order and document to 1)ordering provider or 2)PCP. Do not mark order received.",
      "IF order does not already exist, do not create a new order. Assign the document to 1)ordering provider or 2) PCP.",
      "See Orders Workflow in Notion"
    ],
    assignedTo: "1)ordering provider or 2)PCP",
    displayName: "X-Ray",
    documentLabel: "{{ dateOfEvent }} XR {{ bodyPart }}",
    folder: "Imaging-Xrays",
    folderMapping: "Imaging/X-Rays",
    inputDate: "Procedure Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.IMAGING_RESULTS_X_RAY,
    group: "pinnacle"
  },
  [Classification.INCOMPLETE_CANNOT_LINK_TO_PATIENT]: {
    accountFirstName: "Duplicate And Junk Mail-misc",
    accountId: "9886",
    accountLastName: "ECW-Test",
    additionalWorkflow: null,
    assignedTo: "Rogers,Rod",
    displayName: "Missing PHI - cannot link to patient",
    documentLabel: "{{ dateReceived }} Need more PHI",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Date Received",
    instructions: [
      "DO NOT FILE TO PATIENT CHART - FILE TO MOCK CHART",
      "Workflow Type: Special Cases",
      "MOCK CHART: ECW-Test, Duplicate And Junk Mail-misc (Acct #9886)",
      "Document type: Missing PHI - cannot link to patient",
      "Document label: {{ dateReceived }} Need more PHI",
      "Input date: Date received",
      "Upload to folder: Patient Documents",
      "Assign to: Rogers,Rod"
    ],
    workflowAction: null,
    workflowType: "Special Cases",
    classification: Classification.INCOMPLETE_CANNOT_LINK_TO_PATIENT,
    group: "pinnacle"
  },
  [Classification.INCOMPLETE_ILLEGIBLE]: {
    accountFirstName: "Duplicate And Junk Mail-misc",
    accountId: "9886",
    accountLastName: "ECW-Test",
    additionalWorkflow: null,
    assignedTo: "Rogers,Rod",
    displayName: "Illegible Fax",
    documentLabel: "{{ dateReceived }} Illegible Fax",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Date Received",
    instructions: [
      "DO NOT FILE TO PATIENT CHART - FILE TO MOCK CHART",
      "Workflow Type: Special Cases",
      "MOCK CHART: ECW-Test, Duplicate And Junk Mail-misc (Acct #9886)",
      "Document type: Illegible Fax",
      "Document label: {{ dateReceived }} Illegible Fax",
      "Input date: Date received",
      "Upload to folder: Patient Documents",
      "Assign to: Rogers,Rod"
    ],
    workflowAction: null,
    workflowType: "Special Cases",
    classification: Classification.INCOMPLETE_ILLEGIBLE,
    group: "pinnacle"
  },
  [Classification.INCOMPLETE_NOT_ALL_PAGES]: {
    accountFirstName: "Duplicate And Junk Mail-misc",
    accountId: "9886",
    accountLastName: "ECW-Test",
    additionalWorkflow: null,
    assignedTo: "Rogers,Rod",
    displayName: "Incomplete Fax",
    documentLabel: "{{ dateReceived }} Incomplete Fax",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Date Received",
    instructions: [
      "DO NOT FILE TO PATIENT CHART - FILE TO MOCK CHART",
      "Workflow Type: Special Cases",
      "MOCK CHART: ECW-Test, Duplicate And Junk Mail-misc (Acct #9886)",
      "Document type: Incomplete Fax",
      "Document label: {{ dateReceived }} Incomplete Fax",
      "Input date: Date received",
      "Upload to folder: Patient Documents",
      "Assign to: Rogers,Rod"
    ],
    workflowAction: null,
    workflowType: "Special Cases",
    classification: Classification.INCOMPLETE_NOT_ALL_PAGES,
    group: "pinnacle"
  },
  [Classification.INSURANCE_CARD]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Leave assignment as is & mark as reviewed",
    displayName: "Insurance card",
    documentLabel: "{{ dateReceived }} {{ insuranceCompany }} Ins Card",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Received Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.INSURANCE_CARD,
    group: "pinnacle"
  },
  [Classification.LAB_RESULTS_A1C]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "IF order exists: attach document to order and assign both document and order to 1) ordering provider or 2)PCP. Do not mark order received.",
      "IF no order exists AND imaging was collected in the last 1 year, create an order and assign both order and document to 1)ordering provider or 2)PCP. Do not mark order received.",
      "IF no order exists AND imaging was NOT collected in the last 1 year, do not create an order. Assign document to 1)ordering provider or 2)PCP.",
      "See Orders Workflow in Notion"
    ],
    assignedTo: "1)ordering provider or 2)PCP",
    displayName: "Labs - A1C",
    documentLabel: "{{ dateOfEvent }} A1C",
    folder: "Lab Documents",
    folderMapping: "Lab Documents",
    inputDate: "Collection Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.LAB_RESULTS_A1C,
    group: "pinnacle"
  },
  [Classification.LAB_RESULTS_CBC]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "IF order exists, attach document to order and assign both order and document to 1)ordering provider or 2)PCP. Do not mark order received.",
      "IF order does not already exist, do not create a new order. Assign the document to 1)ordering provider or 2) PCP.",
      "See Orders Workflow in Notion"
    ],
    assignedTo: "1)ordering provider or 2)PCP",
    displayName: "Labs - CBC",
    documentLabel: "{{ dateOfEvent }} CBC",
    folder: "Lab Documents",
    folderMapping: "Lab Documents",
    inputDate: "Collection Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.LAB_RESULTS_CBC,
    group: "pinnacle"
  },
  [Classification.LAB_RESULTS_CMP]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "IF order exists, attach document to order and assign both order and document to 1)ordering provider or 2)PCP. Do not mark order received.",
      "IF order does not already exist, do not create a new order. Assign the document to 1)ordering provider or 2) PCP.",
      "See Orders Workflow in Notion"
    ],
    assignedTo: "1)ordering provider or 2)PCP",
    displayName: "Labs - CMP",
    documentLabel: "{{ dateOfEvent }} CMP",
    folder: "Lab Documents",
    folderMapping: "Lab Documents",
    inputDate: "Collection Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.LAB_RESULTS_CMP,
    group: "pinnacle"
  },
  [Classification.LAB_RESULTS_COLOGUARD]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "IF order exists, attach document to order and assign both order and document to 1)ordering provider or 2)PCP. Do not mark order received.",
      "IF order does not already exist, do not create a new order. Assign the document to 1)ordering provider or 2) PCP.",
      "See Orders Workflow in Notion"
    ],
    assignedTo: "1)ordering provider or 2)PCP",
    displayName: "Labs - Cologuard/FIT or Occult Blood",
    documentLabel: "{{ dateOfEvent }} Cologuard",
    folder: "Lab Documents - Cologuard-FIT",
    folderMapping: "Lab Documents/Cologuard-FIT",
    inputDate: "Collection Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.LAB_RESULTS_COLOGUARD,
    group: "pinnacle"
  },
  [Classification.LAB_RESULTS_DRUG_SCREEN]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "IF order exists, attach document to order and assign both order and document to 1)ordering provider or 2)PCP. Do not mark order received.",
      "IF order does not already exist, do not create a new order. Assign the document to 1)ordering provider or 2) PCP.",
      "See Orders Workflow in Notion"
    ],
    assignedTo: "1)ordering provider or 2)PCP",
    displayName: "Labs - Drug Screening",
    documentLabel: "{{ dateOfEvent }} Drug Screen",
    folder: "Lab Documents - Drug Screen",
    folderMapping: "Lab Documents/Drug Screen",
    inputDate: "Collection Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.LAB_RESULTS_DRUG_SCREEN,
    group: "pinnacle"
  },
  [Classification.LAB_RESULTS_FIT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "IF order exists, attach document to order and assign both order and document to 1)ordering provider or 2)PCP. Do not mark order received.",
      "IF order does not already exist, do not create a new order. Assign the document to 1)ordering provider or 2) PCP.",
      "See Orders Workflow in Notion"
    ],
    assignedTo: "1)ordering provider or 2)PCP",
    displayName: "Labs - Cologuard/FIT or Occult Blood",
    documentLabel: "{{ dateOfEvent }} FIT",
    folder: "Lab Documents - Cologuard-FIT",
    folderMapping: "Lab Documents/Cologuard-FIT",
    inputDate: "Collection Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.LAB_RESULTS_FIT,
    group: "pinnacle"
  },
  [Classification.LAB_RESULTS_LIPID_PANEL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "IF order exists: attach document to order and assign both document and order to 1) ordering provider or 2)PCP. Do not mark order received.",
      "IF no order exists AND imaging was collected in the last 1 year, create an order and assign both order and document to 1)ordering provider or 2)PCP. Do not mark order received.",
      "IF no order exists AND imaging was NOT collected in the last 1 year, do not create an order. Assign document to 1)ordering provider or 2)PCP.",
      "See Orders Workflow in Notion"
    ],
    assignedTo: "1)ordering provider or 2)PCP",
    displayName: "Labs - Lipid Panels",
    documentLabel: "{{ dateOfEvent }} Lipid Panel",
    folder: "Lab Documents",
    folderMapping: "Lab Documents",
    inputDate: "Collection Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.LAB_RESULTS_LIPID_PANEL,
    group: "pinnacle"
  },
  [Classification.LAB_RESULTS_MICROALBUMIN]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "IF order exists: attach document to order and assign both document and order to 1) ordering provider or 2)PCP. Do not mark order received.",
      "IF no order exists AND imaging was collected in the last 1 year, create an order and assign both order and document to 1)ordering provider or 2)PCP. Do not mark order received.",
      "IF no order exists AND imaging was NOT collected in the last 1 year, do not create an order. Assign document to 1)ordering provider or 2)PCP.",
      "See Orders Workflow in Notion"
    ],
    assignedTo: "1)ordering provider or 2)PCP",
    displayName: "Labs - Microalbumin",
    documentLabel: "{{ dateOfEvent }} Microalbumin",
    folder: "Lab Documents",
    folderMapping: "Lab Documents",
    inputDate: "Collection Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.LAB_RESULTS_MICROALBUMIN,
    group: "pinnacle"
  },
  [Classification.LAB_RESULTS_MULTIPLE_LABS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "IF order exists, attach document to order and assign both order and document to 1)ordering provider or 2)PCP. Do not mark order received.",
      "IF order does not already exist, do not create a new order. Assign the document to 1)ordering provider or 2) PCP.",
      "See Orders Workflow in Notion"
    ],
    assignedTo: "1)ordering provider or 2)PCP",
    displayName: "Labs - Multiple",
    documentLabel: "{{ dateOfEvent }} {{ listOfNameOfLabs }} ",
    folder: "Lab Documents",
    folderMapping: "Lab Documents",
    inputDate: "Collection Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.LAB_RESULTS_MULTIPLE_LABS,
    group: "pinnacle"
  },
  [Classification.LAB_RESULTS_ORDER_FORM]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "MA (linked to Pt's PCP)",
    displayName: "Lab Orders (Requisitions that Accompany draw tubes)",
    documentLabel: "{{ dateOfEvent }} Lab Requisition",
    folder: "Lab Documents",
    folderMapping: "Lab Documents",
    inputDate: "Collection Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS_ORDER_FORM,
    group: "pinnacle"
  },
  [Classification.LAB_RESULTS_ORDER_FORM_NEEDS_SIGNATURE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "MA (linked to Pt's PCP)",
    displayName: "Lab Orders needing signature",
    documentLabel: "{{ dateReceived }} Lab Order - Sig Req'd",
    folder: "Lab Documents",
    folderMapping: "Lab Documents",
    inputDate: "Received Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS_ORDER_FORM_NEEDS_SIGNATURE,
    group: "pinnacle"
  },
  [Classification.LAB_RESULTS_OTHER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "IF order exists, attach document to order and assign both order and document to 1)ordering provider or 2)PCP. Do not mark order received.",
      "IF order does not already exist, do not create a new order. Assign the document to 1)ordering provider or 2) PCP.",
      "See Orders Workflow in Notion"
    ],
    assignedTo: "1)ordering provider or 2)PCP",
    displayName: "Labs - Other",
    documentLabel: "{{ dateOfEvent }} {{ nameOfLab }} ",
    folder: "Lab Documents",
    folderMapping: "Lab Documents",
    inputDate: "Collection Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.LAB_RESULTS_OTHER,
    group: "pinnacle"
  },
  [Classification.LAB_RESULTS_PAP_SMEAR]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "IF order exists: attach document to order and assign both document and order to 1) ordering provider or 2)PCP. Do not mark order received, and do not enter results.",
      "IF no order exists AND imaging was collected in the last 3 years, create an order and assign both order and document to 1)ordering provider or 2)PCP. Do not mark order received, and do not enter results.",
      "IF no order exists AND imaging was NOT collected in the last 3 years, do not create an order. Assign document to 1)ordering provider or 2)PCP.",
      "See Orders Workflow in Notion"
    ],
    assignedTo: "1)ordering provider or 2)PCP",
    displayName: "Pap Smear",
    documentLabel: "{{ dateOfEvent }} PAP",
    folder: "Lab Documents - Pathology",
    folderMapping: "Lab Documents/Pathology",
    inputDate: "Collection Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.LAB_RESULTS_PAP_SMEAR,
    group: "pinnacle"
  },
  [Classification.LAB_RESULTS_PATHOLOGY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "IF order exists, attach document to order and assign both order and document to 1)ordering provider or 2)PCP. Do not mark order received.",
      "IF order does not already exist, do not create a new order. Assign the document to 1)ordering provider or 2) PCP.",
      "See Orders Workflow in Notion"
    ],
    assignedTo: "1)ordering provider or 2)PCP",
    displayName: "Pathology Reports/Biopsy Reports",
    documentLabel: "{{ dateOfEvent }} Path Report {{ bodyPart }}",
    folder: "Lab Documents - Pathology",
    folderMapping: "Lab Documents/Pathology",
    inputDate: "Collection Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.LAB_RESULTS_PATHOLOGY,
    group: "pinnacle"
  },
  [Classification.LAB_RESULTS_PT_INR]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "IF order exists, attach document to order and assign both order and document to 1)ordering provider or 2)PCP. Do not mark order received.",
      "IF order does not already exist, do not create a new order. Assign the document to 1)ordering provider or 2) PCP.",
      "See Orders Workflow in Notion"
    ],
    assignedTo: "1)ordering provider or 2)PCP",
    displayName: "Labs - PT-INR",
    documentLabel: "{{ dateOfEvent }} PT-INR",
    folder: "Lab Documents - PT-INR",
    folderMapping: "Lab Documents/PT-INR",
    inputDate: "Collection Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.LAB_RESULTS_PT_INR,
    group: "pinnacle"
  },
  [Classification.LAB_RESULTS_TB]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "MA (linked to Pt's PCP)",
    displayName: "TB Test Result Request",
    documentLabel: "{{ dateReceived }} Dept of Public Health",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS_TB,
    group: "pinnacle"
  },
  [Classification.LAB_RESULTS_TEST_NOT_PERFORMED]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "MA (linked to Pt's PCP)",
    displayName: "Labs - Test Not Performed",
    documentLabel: "{{ dateReceived }} Test Not Performed",
    folder: "Lab Documents",
    folderMapping: "Lab Documents",
    inputDate: "Received Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS_TEST_NOT_PERFORMED,
    group: "pinnacle"
  },
  [Classification.LEGAL_ADVANCED_CARE_DIRECTIVE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Patient's PCP",
    displayName: "Advanced Health Care Directives",
    documentLabel: "{{ dateSigned }} Advance Directive",
    folder: "Advance Directive Documents",
    folderMapping: "AdvDirective Documents",
    inputDate: "Date Signed",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LEGAL_ADVANCED_CARE_DIRECTIVE,
    group: "pinnacle"
  },
  [Classification.LEGAL_POWER_OF_ATTORNEY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Leave assignment as is & mark as reviewed",
    displayName: "Power of Attorney",
    documentLabel: "{{ dateSigned }} POA",
    folder: "Advance Directive Documents",
    folderMapping: "AdvDirective Documents",
    inputDate: "Date Signed",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LEGAL_POWER_OF_ATTORNEY,
    group: "pinnacle"
  },
  [Classification.MEDICAL_HISTORY_CHART_FROM_CLINIC]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Patient's PCP",
    displayName: "Transferred Patient Chart/Records Received/Bulk Records",
    documentLabel: "{{ dateReceived }} {{ clinicName }} Prior Records",
    folder: "Previous Records",
    folderMapping: "Previous Records",
    inputDate: "Received Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_HISTORY_CHART_FROM_CLINIC,
    group: "pinnacle"
  },
  [Classification.MEDICAL_HISTORY_CHART_FROM_HOSPITAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Labs and imaging should be pulled out and indexed per document. Remaining bulk records remain together"
    ],
    assignedTo: "Population,Health",
    displayName: "Hospital Bulk Records",
    documentLabel: "{{ dateReceived }} {{ hospitalAbbrev }} Prior Hospital Records",
    folder: "Hospital, ER and UC Records- Hospital Records",
    folderMapping: "Hospital, ER and UC Records/Hospital Records",
    inputDate: "Received Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_HISTORY_CHART_FROM_HOSPITAL,
    group: "pinnacle"
  },
  [Classification.MEDICAL_HISTORY_HOME_HEALTH]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "McCoy,Kathy",
    displayName: "Home Health Documents",
    documentLabel: "{{ dateOfDocument }} {{ companyName }} HH {{ medicalHistoryType }} {{ orderNumber }} {{ signatureRequired }}",
    folder: "Home Health & Hospice",
    folderMapping: "Home Health & Hospice",
    inputDate: "Date of Notice",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_HISTORY_HOME_HEALTH,
    group: "pinnacle"
  },
  [Classification.MEDICAL_HISTORY_HOSPICE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "McCoy,Kathy",
    displayName: "Hospice Documents",
    documentLabel: "{{ dateOfDocument }} {{ companyName }} {{ medicalHistoryType }} {{ orderNumber }} {{ signatureRequired }}",
    folder: "Home Health & Hospice",
    folderMapping: "Home Health & Hospice",
    inputDate: "Date of Notice",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_HISTORY_HOSPICE,
    group: "pinnacle"
  },
  [Classification.MEDICAL_HISTORY_IMMUNIZATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "MA (linked to Pt's PCP)",
    displayName: "Immunizations/Flu Shots/Vaccination Records",
    documentLabel: "{{ dateReceived }} {{ vaccineType }}",
    folder: "Immunization Forms",
    folderMapping: "Immunization Forms",
    inputDate: "Received Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_HISTORY_IMMUNIZATION,
    group: "pinnacle"
  },
  [Classification.MEDICAL_HISTORY_NUTRITION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Patient's PCP",
    displayName: "Adult Nutritional Assessment",
    documentLabel: "{{ dateOfEvent }} Nutrition",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Date of Consult",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_HISTORY_NUTRITION,
    group: "pinnacle"
  },
  [Classification.MEDICAL_RECORD_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Rogers,Rod",
    displayName: "Medical Records Request",
    documentLabel: "{{ dateReceived }} ROI Request",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Received Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_RECORD_REQUEST,
    group: "pinnacle"
  },
  [Classification.MEDICAL_RECORD_REQUEST_HEDIS]: {
    accountFirstName: "Insurance Reviews",
    accountId: "30559",
    accountLastName: "ECW-Test",
    additionalWorkflow: null,
    assignedTo: "ROI,D Jelly",
    displayName: "HEDIS",
    documentLabel: "{{ dateReceived }} ROI Request",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Date Received",
    instructions: [
      "DO NOT FILE TO PATIENT CHART - FILE TO MOCK CHART",
      "Workflow Type: Special Cases",
      "MOCK CHART: ECW-Test, Insurance Reviews (Acct #30559)",
      "Document type: Medical Records Request - HEDIS or Insurance review w/Multiple Patients pull list",
      "Document label: {{ dateReceived }} ROI Request",
      "Input date: Date received",
      "Upload to folder: Patient Documents",
      "Assign to: ROI,D Jelly"
    ],
    workflowAction: null,
    workflowType: "Special Cases",
    classification: Classification.MEDICAL_RECORD_REQUEST_HEDIS,
    group: "pinnacle"
  },
  [Classification.NOTIFICATION_APPOINTMENT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "MA (linked to Pt's PCP)",
    displayName: "Appt Notifications",
    documentLabel: "{{ dateReceived }} Appt Notice {{ specialty }}",
    folder: "Referral Notes",
    folderMapping: "Referral Notes",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.NOTIFICATION_APPOINTMENT,
    group: "pinnacle"
  },
  [Classification.NOTIFICATION_APPOINTMENT_CANCELLED_MISSED]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "MA (linked to Pt's PCP)",
    displayName: "Appt Cancellations/Missed Appointment",
    documentLabel: "{{ dateReceived }} Missed Appt {{ specialty }}",
    folder: "Referral Notes",
    folderMapping: "Referral Notes",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.NOTIFICATION_APPOINTMENT_CANCELLED_MISSED,
    group: "pinnacle"
  },
  [Classification.NOTIFICATION_HOSPITAL_ADMIT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Population,Health",
    displayName: "Hospital Admit Notice",
    documentLabel: "{{ dateOfEvent }} {{ hospitalAbbrev }} IP Admit Notice",
    folder: "Notifications",
    folderMapping: "Notifications",
    inputDate: "Date of admit",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.NOTIFICATION_HOSPITAL_ADMIT,
    group: "pinnacle"
  },
  [Classification.NOTIFICATION_HOSPITAL_DISCHARGE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Population,Health",
    displayName: "Hospital Discharge Notice",
    documentLabel: "{{ dateOfEvent }} {{ hospitalAbbrev }} IP DC Notice",
    folder: "Notifications",
    folderMapping: "Notifications",
    inputDate: "Date of discharge",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.NOTIFICATION_HOSPITAL_DISCHARGE,
    group: "pinnacle"
  },
  [Classification.NOTIFICATION_HOSPITAL_ER_ADMIT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Population,Health",
    displayName: "Hospital ER Admit Notification",
    documentLabel: "{{ dateOfEvent }} {{ hospitalAbbrev }} ER Admit Notice",
    folder: "Notifications",
    folderMapping: "Notifications",
    inputDate: "Date of admit",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.NOTIFICATION_HOSPITAL_ER_ADMIT,
    group: "pinnacle"
  },
  [Classification.NOTIFICATION_HOSPITAL_ER_DISCHARGE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Population,Health",
    displayName: "Hospital ER Discharge Notification",
    documentLabel: "{{ dateOfEvent }} {{ hospitalAbbrev }} ER DC Notice",
    folder: "Notifications",
    folderMapping: "Notifications",
    inputDate: "Date of discharge",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.NOTIFICATION_HOSPITAL_ER_DISCHARGE,
    group: "pinnacle"
  },
  [Classification.NOTIFICATION_HOSPITAL_SDS_ADMIT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Population,Health",
    displayName: "Hospital SDS Admit Notification",
    documentLabel: "{{ dateOfEvent }} {{ hospitalAbbrev }} SDS Admit Notice",
    folder: "Notifications",
    folderMapping: "Notifications",
    inputDate: "Date of admit",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.NOTIFICATION_HOSPITAL_SDS_ADMIT,
    group: "pinnacle"
  },
  [Classification.NOTIFICATION_HOSPITAL_SDS_DISCHARGE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Population,Health",
    displayName: "Hospital SDS Discharge Notification",
    documentLabel: "{{ dateOfEvent }} {{ hospitalAbbrev }} SDS DC Notice",
    folder: "Notifications",
    folderMapping: "Notifications",
    inputDate: "Date of discharge",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.NOTIFICATION_HOSPITAL_SDS_DISCHARGE,
    group: "pinnacle"
  },
  [Classification.PHARMACY_RELATED_ALERT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Patient's PCP",
    displayName: "Rx Therapeutic Alerts",
    documentLabel: "{{ dateReceived }} Therapeutic Alert",
    folder: "Medications",
    folderMapping: "Medications",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED_ALERT,
    group: "pinnacle"
  },
  [Classification.PHARMACY_RELATED_CARE_CONSIDERATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Patient's PCP",
    displayName: "Rx Care Considerations",
    documentLabel: "{{ dateReceived }} Care Consideration",
    folder: "Medications",
    folderMapping: "Medications",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED_CARE_CONSIDERATION,
    group: "pinnacle"
  },
  [Classification.PHARMACY_RELATED_CLARIFICATION]: {
    accountFirstName: "Prescription Refill",
    accountId: "62707",
    accountLastName: "ECW-Test",
    additionalWorkflow: null,
    assignedTo: "Prescription,MA",
    displayName: "Rx Clarification",
    documentLabel: "{{ dateReceived }} Rx Clarification",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Date Received",
    instructions: [
      "DO NOT FILE TO PATIENT CHART - FILE TO MOCK CHART",
      "Workflow Type: Special Cases",
      "MOCK CHART: ECW-Test, Prescription Refill (Acct #62707)",
      "Document type: Rx Clarification",
      "Document label: {{ dateReceived }} Rx Clarification",
      "Input date: Date received",
      "Upload to folder: Patient Documents",
      "Assign to: Prescription,MA"
    ],
    workflowAction: null,
    workflowType: "Special Cases",
    classification: Classification.PHARMACY_RELATED_CLARIFICATION,
    group: "pinnacle"
  },
  [Classification.PHARMACY_RELATED_CONTROLED_SUBSTANCES_POLICY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Leave assignment as is & mark as reviewed",
    displayName: "Controlled Substance Policy",
    documentLabel: "{{ dateSigned }} Controlled Substance Policy",
    folder: "Controlled Substances",
    folderMapping: "Controlled Substances",
    inputDate: "Date of Signature",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED_CONTROLED_SUBSTANCES_POLICY,
    group: "pinnacle"
  },
  [Classification.PHARMACY_RELATED_DRUG_MONITORING_PROGRAM]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Patient's PCP",
    displayName: "Rx Prescription Drug Monitoring Program (PDMP) Documents",
    documentLabel: "{{ dateReceived }} PDMP",
    folder: "Controlled Substances",
    folderMapping: "Controlled Substances",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED_DRUG_MONITORING_PROGRAM,
    group: "pinnacle"
  },
  [Classification.PHARMACY_RELATED_NON_ADHERENCE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Patient's PCP",
    displayName: "Rx Non Adherence",
    documentLabel: "{{ dateReceived }} Med Non-Adher",
    folder: "Medications",
    folderMapping: "Medications",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED_NON_ADHERENCE,
    group: "pinnacle"
  },
  [Classification.PHARMACY_RELATED_REFILL]: {
    accountFirstName: "Prescription Refill",
    accountId: "62707",
    accountLastName: "ECW-Test",
    additionalWorkflow: null,
    assignedTo: "Prescription,MA",
    displayName: "Rx Refill",
    documentLabel: "{{ dateReceived }} RX {{ medications }}",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Date Received",
    instructions: [
      "DO NOT FILE TO PATIENT CHART - FILE TO MOCK CHART",
      "Workflow Type: Special Cases",
      "MOCK CHART: ECW-Test, Prescription Refill (Acct #62707)",
      "Document type: Rx Refill",
      "Document label: {{ dateReceived }} RX {{ medications }}",
      "Input date: Date received",
      "Upload to folder: Patient Documents",
      "Assign to: Prescription,MA"
    ],
    workflowAction: null,
    workflowType: "Special Cases",
    classification: Classification.PHARMACY_RELATED_REFILL,
    group: "pinnacle"
  },
  [Classification.PHARMACY_RELATED_REFILL_MANY]: {
    accountFirstName: "Prescription Refill",
    accountId: "62707",
    accountLastName: "ECW-Test",
    additionalWorkflow: null,
    assignedTo: "Prescription,MA",
    displayName: "Rx Refill Req (multiple meds)",
    documentLabel: "{{ dateReceived }} RX {{ medications }}",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Date Received",
    instructions: [
      "DO NOT FILE TO PATIENT CHART - FILE TO MOCK CHART",
      "Workflow Type: Special Cases",
      "MOCK CHART: ECW-Test, Prescription Refill (Acct #62707)",
      "Document type: Rx Refill - multiple meds",
      "Document label: {{ dateReceived }} RX {{ medications }}",
      "Input date: Date received",
      "Upload to folder: Patient Documents",
      "Assign to: Prescription,MA"
    ],
    workflowAction: null,
    workflowType: "Special Cases",
    classification: Classification.PHARMACY_RELATED_REFILL_MANY,
    group: "pinnacle"
  },
  [Classification.PRIOR_AUTHORIZATION_MEDICATION_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "MA (linked to Pt's PCP)",
    displayName: "Rx Prior Auth Request",
    documentLabel: "{{ dateReceived }} {{ medicationName }} PA Request",
    folder: "Medications",
    folderMapping: "Medications",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_MEDICATION_REQUEST,
    group: "pinnacle"
  },
  [Classification.PRIOR_AUTHORIZATION_MEDICATION_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "MA (linked to Pt's PCP)",
    displayName: "Rx Prior Auth Approval/Denial Letter",
    documentLabel: "{{ dateReceived }} {{ medicationName }} PA {{authorizationStatus}}",
    folder: "Medications",
    folderMapping: "Medications",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_MEDICATION_RESPONSE,
    group: "pinnacle"
  },
  [Classification.PRIOR_AUTHORIZATION_PROCEDURE_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "MA (linked to Pt's PCP)",
    displayName: "Procedure/Service Prior Auth Request",
    documentLabel: "{{ dateReceived }} PA Req {{ procedure }}",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Received Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_PROCEDURE_REQUEST,
    group: "pinnacle"
  },
  [Classification.PRIOR_AUTHORIZATION_PROCEDURE_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "MA (linked to Pt's PCP)",
    displayName: "Procedure/Service Prior Auth Approvals/Denials",
    documentLabel: "{{ dateReceived }} {{ specialty }} {{authorizationStatus}}",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Received Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_PROCEDURE_RESPONSE,
    group: "pinnacle"
  },
  [Classification.PROCEDURE_CARDIAC]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Patient's PCP",
    displayName: "Cardiac Procedures (Angiograms, Heart Caths)",
    documentLabel: "{{ dateOfEvent }} {{ procedure }}",
    folder: "Imaging - Cardiac Tests",
    folderMapping: "Imaging/Cardiac Tests",
    inputDate: "Date of Procedure",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROCEDURE_CARDIAC,
    group: "pinnacle"
  },
  [Classification.PROCEDURE_GI]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "IF order exists, attach document to order and assign both order and document to 1)ordering provider or 2)PCP. Do not mark order received.",
      "IF order does not already exist, do not create a new order. Assign the document to 1)ordering provider or 2) PCP.",
      "See Orders Workflow in Notion"
    ],
    assignedTo: "1)ordering provider or 2)PCP",
    displayName: "EGD",
    documentLabel: "{{ dateOfEvent }} EGD",
    folder: "Procedure Documents",
    folderMapping: "Procedure Documents",
    inputDate: "Date of Procedure",
    instructions: null,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.PROCEDURE_GI,
    group: "pinnacle"
  },
  [Classification.PROCEDURE_SLEEP]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "IF order exists, attach document to order and assign both order and document to 1)ordering provider or 2)PCP. Do not mark order received.",
      "IF order does not already exist, do not create a new order. Assign the document to 1)ordering provider or 2) PCP.",
      "See Orders Workflow in Notion"
    ],
    assignedTo: "1)ordering provider or 2)PCP",
    displayName: "Sleep Study",
    documentLabel: "{{ dateOfEvent }} Sleep Study",
    folder: "Pulmonary Tests",
    folderMapping: "Pulmonary Tests",
    inputDate: "Date of Study",
    instructions: null,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.PROCEDURE_SLEEP,
    group: "pinnacle"
  },
  [Classification.PROGRESS_NOTE_ER_REPORT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Population,Health",
    displayName: "Hospital ER Reports",
    documentLabel: "{{ dateOfEvent }} {{ hospitalAbbrev }} ER Report",
    folder: "Hospital, ER and UC Records - ER Records",
    folderMapping: "Hospital, ER and UC Records/ER Records",
    inputDate: "Date of service",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_ER_REPORT,
    group: "pinnacle"
  },
  [Classification.PROGRESS_NOTE_ER_SUMMARY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Population,Health",
    displayName: "Hospital ER Summary of Care",
    documentLabel: "{{ dateOfEvent }} {{ hospitalAbbrev }} ER Summary of Care",
    folder: "Hospital, ER and UC Records - ER Records",
    folderMapping: "Hospital, ER and UC Records/ER Records",
    inputDate: "Date of discharge",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_ER_SUMMARY,
    group: "pinnacle"
  },
  [Classification.PROGRESS_NOTE_HOSPITAL_DISCHARGE_SUMMARY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Population,Health",
    displayName: "Hospital Discharge Summary",
    documentLabel: "{{ dateOfEvent }} {{ hospitalAbbrev }} DC",
    folder: "Hospital, ER and UC Records- Hospital Records",
    folderMapping: "Hospital, ER and UC Records/Hospital Records",
    inputDate: "Date of discharge",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_HOSPITAL_DISCHARGE_SUMMARY,
    group: "pinnacle"
  },
  [Classification.PROGRESS_NOTE_HOSPITAL_OFFICE_VISIT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Patient's PCP",
    displayName: "Attending Physicians Statements",
    documentLabel: "{{ dateOfEvent }} Progress Note {{ specialty }}",
    folder: "Hospital, ER and UC Records- Hospital Records",
    folderMapping: "Hospital, ER and UC Records/Hospital Records",
    inputDate: "Date of Consult",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_HOSPITAL_OFFICE_VISIT,
    group: "pinnacle"
  },
  [Classification.PROGRESS_NOTE_HOSPITAL_RECORDS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Population,Health",
    displayName: "Hospital Progress Note",
    documentLabel: "{{ dateOfEvent }} {{ hospitalAbbrev }} Progress Note",
    folder: "Hospital, ER and UC Records- Hospital Records",
    folderMapping: "Hospital, ER and UC Records/Hospital Records",
    inputDate: "Date of service",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_HOSPITAL_RECORDS,
    group: "pinnacle"
  },
  [Classification.PROGRESS_NOTE_HOSPITAL_SUMMARY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Population,Health",
    displayName: "Hospital Discharge Summary of Care",
    documentLabel: "{{ dateOfEvent }} {{ hospitalAbbrev }} Summary of Care",
    folder: "Hospital, ER and UC Records- Hospital Records",
    folderMapping: "Hospital, ER and UC Records/Hospital Records",
    inputDate: "Date of discharge",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_HOSPITAL_SUMMARY,
    group: "pinnacle"
  },
  [Classification.PROGRESS_NOTE_OFFICE_VISIT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Assign document to PCP",
      "Look in the patient's outgoing referrals to see if the patient was referred for the visit",
      "Proceed through Consults Workflow to close out referral (see Consults Workflow in Notion)"
    ],
    assignedTo: "Patient's PCP",
    displayName: "Consults from Specialists or Outside Providers",
    documentLabel: "{{ dateOfEvent }} {{ specialtyFolder }}",
    folder: "Consult Notes - Subfolder per {{ specialtyFolder }}",
    folderMapping: "Consult Notes/{{ specialtyFolder }}",
    inputDate: "Date of Consult",
    instructions: null,
    workflowAction: null,
    workflowType: "Consult/Referrals WF",
    classification: Classification.PROGRESS_NOTE_OFFICE_VISIT,
    group: "pinnacle"
  },
  [Classification.PROGRESS_NOTE_OPERATIVE_REPORT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Patient's PCP",
    displayName: "Operative Report",
    documentLabel: "{{ dateOfEvent }} Op Report {{ surgeryName }}",
    folder: "Hospital, ER and UC Records- Hospital Records",
    folderMapping: "Hospital, ER and UC Records/Hospital Records",
    inputDate: "Date of Procedure",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_OPERATIVE_REPORT,
    group: "pinnacle"
  },
  [Classification.PROGRESS_NOTE_PT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Patient's PCP",
    displayName: "Therapy Consults/Plan of Care/PT/OT/ST",
    documentLabel: "{{ dateReceived }} {{ progressNoteType }} {{ documentType }} {{ signatureRequired }} {{ orderNumber }}",
    folder: "Consult Notes - Physical Therapy",
    folderMapping: "Consult Notes/Physical Therapy",
    inputDate: "Received Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_PT,
    group: "pinnacle"
  },
  [Classification.PROGRESS_NOTE_URGENT_CARE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Population,Health",
    displayName: "Hospital-Urgent Care Report",
    documentLabel: "{{ dateOfEvent }} Urgent Care",
    folder: "Hospital, ER and UC Records- Urgent Care",
    folderMapping: "Hospital, ER and UC Records/Urgent Care",
    inputDate: "Date of visit",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_URGENT_CARE,
    group: "pinnacle"
  },
  [Classification.REFERRAL_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Location referrals",
    displayName: "Referral Request",
    documentLabel: "{{ dateOfDocument }} {{ specialty }}",
    folder: "Referral Notes",
    folderMapping: "Referral Notes",
    inputDate: "Date of request",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.REFERRAL_REQUEST,
    group: "pinnacle"
  },
  [Classification.REFERRAL_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Location referrals",
    displayName: "Referral Response",
    documentLabel: "{{ dateReceived }} Referral Response {{ specialty }}",
    folder: "Referral Notes",
    folderMapping: "Referral Notes",
    inputDate: "Received Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.REFERRAL_RESPONSE,
    group: "pinnacle"
  }
} as const;
